import { Component, Vue, Mixins, Prop, Emit } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from "@/util/BASEAPI";
import { OCMailAuthenticationResponse } from '@/components/OCMailAuthentication';
import { EmailPass } from '@/generated/api';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import OCTtlMain from '@/components/OCTtlMain.vue';
import OCButtonSmall from '@/components/OCButtonSmall.vue';
import OCFormLabel from '@/components/OCFormLabel.vue';
import OCTextBox from '@/components/OCTextBox.vue';
import OCMailAuthentication from '@/components/OCMailAuthentication.vue';

@Component({
    components: {
        OCTtlMain,
        OCButtonSmall,
        OCFormLabel,
        OCTextBox,
        OCMailAuthentication
    },
})
export default class PassRemind extends Mixins(CommonView) {
    pnkzList: {name: string, path: string | null}[] = [];

    mode: number = 0;

    emailPass: EmailPass = {
        code: "",
        email: "",
        pass: ""
    };

    @Prop({
        type: Object,
        default: null,
    })
    newUserToReminder!: OCMailAuthenticationResponse | null;

    passConfirmation: string = "";
    error: string = "";
    kurukuru: boolean = false;
    element: HTMLElement = <HTMLElement>document.scrollingElement;

    @Emit("signup")
    public signup(val: OCMailAuthenticationResponse) {
        return val;
    }

    public async created() {
        if (this.newUserToReminder) {
            this.emailPass.email = this.newUserToReminder.email;
            this.emailPass.code = this.newUserToReminder.code;
            this.mode = 1;
        }

        this.pnkzList = [
            {name: "TOP", path: "/"},
            {name: "パスワード再設定", path: null}
        ];
    }

    public check1(val: OCMailAuthenticationResponse) {
        if (!val.user) {
            this.signup(val);
            return;
        }
        this.emailPass.email = val.email;
        this.emailPass.code = val.code;
        this.element.scrollTop = 0;
        this.mode = 1;
    }

    public async check2() {
        this.kurukuru = true;

        if (!this.emailPass.pass || !this.passConfirmation) {
            this.kurukuru = false;
            this.error = "パスワードを入力してください。";
            this.element.scrollTop = 0;
            return;
        }

        if (this.emailPass.pass != this.passConfirmation) {
            this.kurukuru = false;
            this.error = "パスワードが一致しません。";
            this.element.scrollTop = 0;
            return;
        }

        let res = await BASEAPI.UserController.putLoginPassUsingPUT(this.emailPass).catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
        } else {
            this.getUserAPI();
            this.mode = 2;
        }
        this.element.scrollTop = 0;
        this.kurukuru = false;
    }

    public back(value: number) {
        this.mode = value;
        this.element.scrollTop = 0;
    }

    public backRedirect() {
        this.$router.push("/");
    }
}

